import * as CursorSpinner from '../src/components/CursorSpinner';
import {eshopUserToolsRefresh} from './eshopUserToolsRefresh';
import $ from 'jquery';

/**
 * product tools event handlers
 */
export default (props, e) => {
	const {
		ajaxHref,
		activeClass,
	} = props;

	const self = e.target;

	e.preventDefault();

	CursorSpinner.pushToQueue('eshopUserToolsHandle');

	$.post(ajaxHref, function(data) {
		if(data.ok) {
			CursorSpinner.removeFromQueue('eshopUserToolsHandle');

			eshopUserToolsRefresh();

			if (self.classList.contains(activeClass)) {
				self.href = self.href.replace('removeItem', 'addItem');
				self.setAttribute('data-ajax-href', ajaxHref.replace('removeItemJson', 'addItemJson'));
			} else {
				self.href = self.href.replace('addItem', 'removeItem');
				self.setAttribute('data-ajax-href', ajaxHref.replace('addItemJson', 'removeItemJson'));
			}
			self.classList.toggle(activeClass);
		}
	});
};


// WEBPACK FOOTER //
// ./node_modules/fg-frontend/webActions/eshopUserToolsHandle.js